module.exports = __webpack_public_path__ + "img/turnpage-right-next.9888c2f7.svg";